import { CssSelectors } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	modal: {
		...CssSelectors.allDescendants(
			{
				borderRadius: 8,
				boxSizing: 'content-box',
				padding: 18,
				maxWidth: 1000,
			},
			'.modal-overlay-content'
		),
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 900,
		padding: 16,
		paddingTop: 0,
	},
	title: {
		color: '#0265FF',
		margin: 0,
		marginTop: '-8px',
	},
	subTitle: {
		marginTop: 20,
		marginBottom: 16,
	},
	content: {
		marginTop: 16,
		// 260px accounts for modal chrome: padding (18×2), container padding (16×2), title, subtitle margins, footer
		maxHeight: 'calc(100vh - 260px)',
		overflowY: 'auto',
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-start',
		gap: 16,
		marginTop: 24,
	},
	table: {
		borderCollapse: 'collapse',
		width: '100%',
		fontSize: 14,
	},
	th: {
		color: '#9198A4',
		fontWeight: 400,
		padding: '8px 16px',
		textAlign: 'left',
		borderBottom: '1px solid #E9EBEF',
	},
	td: {
		padding: '12px 16px',
		borderBottom: '1px solid #E9EBEF',
		verticalAlign: 'middle',
	},
	centered: {
		textAlign: 'center',
	},
	nameCell: {
		width: 220,
	},
	smallCell: {
		width: 75,
	},
	mediumCell: {
		width: 100,
	},
	actionCell: {
		width: 140,
	},
	nameCellContent: {
		display: 'flex',
		flexDirection: 'column',
	},
	nameWithIcon: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
	},
	name: {},
	secondRow: {
		fontSize: 12,
		color: '#9198A4',
	},
});
